import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Additionals} from '../additionals';
import {AdditionalsService} from '../additionals.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {Http, RequestOptions, ResponseContentType} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {formatDate} from "ngx-bootstrap/chronos";
import {CustomerService} from "../../../setting/customers/customer.service";
import {ItemService} from "../../../setting/items/items.service";
import {AccountsService} from "../../accounts/accounts.service";
import {AccountsShowComponent} from "../../accounts/accounts-show/accounts-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {PurchasesShowComponent} from "../../../pro/purchases/purchases-show/purchases-show.component";
import {ReturninvoicesShowComponent} from "../../../pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {InvoicesShowComponent} from "../../../pos/invoices/invoices-show/invoices-show.component";
import {JournalsShowComponent} from "../../journals/journals-show/journals-show.component";
import {ExpenseVouchersShowComponent} from "../../expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {CurrencyMaskModule} from 'ng2-currency-mask';

@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MyInputsModule, MessagesModule,CurrencyMaskModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        AdditionalsShowComponent
    ],
    entryComponents: [
        AdditionalsShowComponent
    ],
    exports: [],
    providers: [SharedService, AdditionalsService, MessageService, ConfirmationService,AccountsService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-invoices-show',
    templateUrl: './additionals-show.component.html',
    styleUrls: ['./additionals-show.component.scss'],
    providers: [AdditionalsService, ConfirmationService, MessageService, CustomerService,ItemService,AccountsService]
})

export class AdditionalsShowComponent implements OnInit, AfterViewInit {
  id: string;
  picture: string;
  additional: Additionals;
  status: string;

  invoices_groups_id: string;
  statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
  form: FormGroup;
  showDocNo = 1;

  private sub: any;

  today = formatDate(new Date(),"YYYY-MM-DD");
  @Input() scrId;
  modalRef: NgbModalRef;
  @Input() modelName;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;

    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private invoiceService: AdditionalsService,
                private accountsService: AccountsService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private customerservice: CustomerService,
                private itemservice: ItemService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(AdditionalsShowComponent);
        this.sharedservice.setButtons([
          {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
          {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
          // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
          {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
          {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('additionals');
        this.modelName = this.sharedservice.getModelName();
    }
    print() {
      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      const tokenapi = userdata.api_token;
      const options = new RequestOptions({responseType: ResponseContentType.Blob });
      window.open(appConfig.apiUrl + 'additionals/print/'+this.id+'?token='+ tokenapi )
    }


    recordData() {
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.additional;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if (!this.scrId) {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');


        if (this._editButton) {
          this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/additionals/edit', this.id]);
          });
        }
        if (this._deleteButton) {

          this._deleteButton.onclick = ((e: any) => {
            e.preventDefault();
            //this.deleteAdditionals();
          });
        }
        if (this._newButton) {

          this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/additionals']);
          });

        }
        if (this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/additionals/search']);
          });

        }

        if (this._printButton) {
          this._printButton.onclick = ((e: any) => {
            e.preventDefault();
            this.print();
          });

        }
      }
    }

    ngOnInit() {

      this.additional = new Additionals();
      this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
          id: new FormControl({value: '', disabled: true}),
          from_date: new FormControl({value: '', disabled: true}),
          to_date: new FormControl({value: '', disabled: true}),
          purchases_imports_reverse_calculation: new FormControl({value: '', disabled: true}),
          ​purchases_imports_reverse_calculation_return: new FormControl({value: '', disabled: true}),
          ​purchases_imports_reverse_calculation_tax: new FormControl({value: '', disabled: true}),
          ​purchases_imports_with_additional: new FormControl({value: '', disabled: true}),
          ​purchases_imports_with_additional_return: new FormControl({value: '', disabled: true}),
          ​purchases_imports_with_additional_tax: new FormControl({value: '', disabled: true}),
          ​purchases_taxfree: new FormControl({value: '', disabled: true}),
          ​purchases_taxfree_return: new FormControl({value: '', disabled: true}),
          ​purchases_with_additional: new FormControl({value: '', disabled: true}),​
          purchases_with_additional_return: new FormControl({value: '', disabled: true}),
          ​purchases_with_additional_tax: new FormControl({value: '', disabled: true}),
          ​purchases_with_zero: new FormControl({value: '', disabled: true}),
          ​purchases_with_zero_return: new FormControl({value: '', disabled: true}),
          ​sales_citizens: new FormControl({value: '', disabled: true}),
          ​sales_citizens_return: new FormControl({value: '', disabled: true}),
          ​sales_exports: new FormControl({value: '', disabled: true}),
          ​sales_exports_return: new FormControl({value: '', disabled: true}),
          ​sales_local_zero: new FormControl({value: '', disabled: true}),
          ​sales_local_zero_return: new FormControl({value: '', disabled: true}),
          ​sales_taxfree: new FormControl({value: '', disabled: true}),
          ​sales_taxfree_return: new FormControl({value: '', disabled: true}),
          ​sales_with_additional: new FormControl({value: '', disabled: true}),
          ​sales_with_additional_return: new FormControl({value: '', disabled: true}),
          ​sales_with_additional_tax: new FormControl({value: '', disabled: true}),
          total_sales: new FormControl({value: '', disabled: true}),
          total_sales_return: new FormControl({value: '', disabled: true}),
          total_sales_tax: new FormControl({value: '', disabled: true}),
          total_purchases: new FormControl({value: '', disabled: true}),
          total_purchases_return: new FormControl({value: '', disabled: true}),
          total_purchases_tax: new FormControl({value: '', disabled: true}),
          total_tax: new FormControl({value: '', disabled: true}),
          old_peroid_fixes: new FormControl({value: '', disabled: true}),
          old_peroid_tax: new FormControl( {value: '', disabled: true}),
          final_tax: new FormControl({value: '', disabled: true}),

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.newDatap = true;
            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }

            this.invoiceService.getById(this.id).subscribe(
              additional => {
                this.id = additional.id;
                this.additional = additional;
                this.form.patchValue(additional);
              }, error => {
                console.log(error);
              }
            );


        }
        if(this.scrId){
            this.oldData = false;
            this.newData = false;
            this.delId = false;

          this.invoiceService.getById(this.scrId).subscribe(
            additional => {
              this.id = additional.id;
              this.additional = additional;
              this.form.patchValue(additional);


            }, error => {
              console.log(error);
            }
          );


        }
        if(this.delId){
          this.oldData = false;
          this.newData = false;
          this.newDatap = !this.newDatap ;
          this.invoiceService.getTrashedById(this.delId).subscribe(
            additional => {
              this.id = additional.id;
              this.additional = additional;
              this.form.patchValue(additional);
            }, error => {
              console.log(error);
            }
          );
        }

        if (this.oldData && this.newData) {
            this.additional = this.newData;
            console.log('new', this.newData, 'old', this.oldData);
            this.form.patchValue(this.newData);
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        //console.log(userRoles.indexOf('pos.invoices.' + role));
        if (userRoles.indexOf('pos.invoices.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteAdditionals(invoice: Additionals) {
      this.confirmationService.confirm({
          header: this.translate.instant('Confirm Delete'),
          message: this.translate.instant('Are you sure of delete ?'),
          icon: 'fa fa-trash',
          accept: () => {
            if (invoice) {
              this.invoiceService.delete(invoice.id).subscribe(
                res => {
                  this.msgs = [];
                  if(res.result){
                    this.msgs.push({
                      severity: 'success',
                      summary: '',
                      detail: this.translate.instant('Delete completed')
                    });
                    setTimeout(() => {
                      this.router.navigate(['/additionals']);
                    },1000);
                  }
                  else{
                    this.msgs.push({
                      severity: 'error',
                      summary: '',
                      detail: this.translate.instant(res.message)
                    });
                  }
                  localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  window.scroll(0,0);
                }
              );
            }
          }
      });
    }

    recoverEdit(invoice: Additionals) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (invoice) {
                    this.invoiceService.update(invoice).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/additionals/show', invoice.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.invoiceService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted invoice recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/additionals/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    //console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;

    }
  }
  showHistory(row_id: string) {
     // console.log("12121212");
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppLogComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.refShow = AdditionalsShowComponent;
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/views/fin/additionals/additionals-show/additionals-show.component.ts